var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "mini",
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("desearchbutton.text"), prop: "text" } },
            [
              _c("el-input", {
                attrs: { maxlength: "10", "show-word-limit": "" },
                model: {
                  value: _vm.currentElement.options.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentElement.options, "value", $$v)
                  },
                  expression: "currentElement.options.value",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("desearchbutton.auto_trigger") } },
            [
              _c("el-switch", {
                on: { change: _vm.autoTriggerChange },
                model: {
                  value: _vm.myAttrs.autoTrigger,
                  callback: function ($$v) {
                    _vm.$set(_vm.myAttrs, "autoTrigger", $$v)
                  },
                  expression: "myAttrs.autoTrigger",
                },
              }),
              _c(
                "el-link",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "info", disabled: "" },
                },
                [_vm._v(_vm._s(_vm.$t("desearchbutton.auto_trigger_tip")))]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("desearchbutton.range") } },
            [
              _c("el-switch", {
                on: { change: _vm.customRangeChange },
                model: {
                  value: _vm.myAttrs.customRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.myAttrs, "customRange", $$v)
                  },
                  expression: "myAttrs.customRange",
                },
              }),
              _c(
                "el-link",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "warning", disabled: "" },
                },
                [_vm._v(_vm._s(_vm.$t("desearchbutton.range_tip")))]
              ),
            ],
            1
          ),
          _vm.myAttrs.customRange
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("desearchbutton.relative") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { multiple: "", clearable: "" },
                      model: {
                        value: _vm.myAttrs.filterIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.myAttrs, "filterIds", $$v)
                        },
                        expression: "myAttrs.filterIds",
                      },
                    },
                    _vm._l(_vm.filters, function (filter, index) {
                      return _c("el-option", {
                        key: filter.id + index,
                        attrs: { label: filter.showName, value: filter.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sure } },
                [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("commons.cancel"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }